module.exports = __webpack_public_path__ + "img/check-double.dfb7be13.svg";